export default __webpack_public_path__ + "static/media/logo.c50e6add.png";